import "./css/IntroPage.css";
import "./css/partner.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faChevronLeft, faPause, faPlay, faCheck, faCirclePlay, faCirclePause } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { PartnerDetails } from "./data/partner";

const Partner = () => {
    const [isPaused, setIsPaused] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [direction, setDirection] = useState("next");

    const runAutoInterval = useRef(null);
    const totalSlides = PartnerDetails.length;

    useEffect(() => {
        const timeAutoNext = 7000;

        function startAutoPlay() {
            clearInterval(runAutoInterval.current);
            runAutoInterval.current = setInterval(() => {
                handleSlideChange("next");
            }, timeAutoNext);
        }

        function stopAutoPlay() {
            clearInterval(runAutoInterval.current);
        }

        if (!isPaused) startAutoPlay();
        else stopAutoPlay();

        return () => {
            stopAutoPlay();
        };
    }, [isPaused, currentIndex]);

    const handleSlideChange = (dir) => {
        setDirection(dir);
        setCurrentIndex((prev) => {
            if (dir === "next") return (prev + 1) % totalSlides;
            else return (prev - 1 + totalSlides) % totalSlides;
        });
    };

    return (
        <>
            <div className="ptr-carousel">
                <div className="ptr-triangle triangle-gray"></div>
                <div className="ptr-triangle triangle-yellow"></div>
                <div className="ptr-triangle triangle-yellow-2"></div>

                <div className="ptr-inner" id="partner-slider">
                    <>
                        {PartnerDetails.map((item, index) => (
                            <div
                                className={`row ptr-slider-item ${index === currentIndex ? "active" : ""}`}
                                key={index}
                                style={{ display: index === currentIndex ? "block" : "none" }}
                            >
                                <div className="ptr-wrapper">
                                    <div className="ptr-render-container">
                                        <div className="row ptr-render-area">

                                            {/* LEFT — text content */}
                                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 p-content-area">
                                                <div className="ptr-item-align">
                                                    <div className="ptr-width-flex">
                                                        <div className="partner-list">
                                                            <div className="partner-content">
                                                                <div className="partner-sub-content">
                                                                    <a href={item.url} target="_blank" rel="noopener noreferrer" className="text-header">
                                                                        {item.title}
                                                                    </a>
                                                                </div>
                                                                <div className="partner-text-content">
                                                                    <div className="partner-sections-wrapper">
                                                                        <div className="partner-section1">
                                                                            {item.section ? (
                                                                                item.section.map((text, idx) => (
                                                                                    <div className="partner-name content text-body" key={idx}>
                                                                                        <FontAwesomeIcon icon={faCheck} className="tool-icon" />
                                                                                        {text}
                                                                                    </div>
                                                                                ))
                                                                            ) : item.title === "ServiceNow Partner" ? (
                                                                                <>
                                                                                    <div className="partner-name content text-body">
                                                                                        <FontAwesomeIcon icon={faCheck} className="tool-icon" />
                                                                                        End-to-end implementation of the ServiceNow AI-powered platform, tailored to your business needs.
                                                                                    </div>
                                                                                    <div className="partner-name content text-body">
                                                                                        <FontAwesomeIcon icon={faCheck} className="tool-icon" />
                                                                                        Development of custom ServiceNow Store applications that enhance the platform's capabilities and drive greater value for customers.
                                                                                    </div>
                                                                                </>
                                                                            ) : (
                                                                                <div className="partner-name content text-body">
                                                                                    <FontAwesomeIcon icon={faCheck} className="tool-icon" />
                                                                                    {item.desc}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* RIGHT — image */}
                                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 banner-img-area ptr-img-area">
                                                <div className="content-img-align">
                                                    <div
                                                        className={`ptr-thumbnail-item ${index === currentIndex ? "active" : "inactive"} ${direction}`}
                                                    >
                                                        <img
                                                            className="partner-thumbnail-img img-border"
                                                            src={item.image}
                                                            alt="partner-thumbnail"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </>

                    {/* Arrows — exactly mirrors Products page */}
                    <div className="ptr-arrows">
                        <button id="ptr-prev" className="arrow-btn" onClick={() => handleSlideChange("prev")}>
                            <FontAwesomeIcon icon={faChevronLeft} className="arrow-icon" />
                        </button>

                        <button id="partner-pause" className="product-arrow-btn" onClick={() => setIsPaused((prev) => !prev)}>
                            <FontAwesomeIcon icon={isPaused ? faPlay : faPause} className="arrow-icon" />
                        </button>

                        <button id="ptr-next" className="arrow-btn" onClick={() => handleSlideChange("next")}>
                            <FontAwesomeIcon icon={faChevronRight} className="arrow-icon" />
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Partner;